







































































































import { Vue, Component } from 'vue-property-decorator'
import moment from 'moment'
const shortid = require("shortid")

@Component
export default class Users extends Vue {
    selected = null
    filterRadioValue="first"
    mandateOptions = [
            { value: null, text: 'Valitse' },
          { value: 'Yritys', text: 'Yritys' },
          { value: 'Yhdistys', text: 'Yhdistys' }
    ]

    userModel = {
        _id: "",
        firstName: "",
        lastName: "",
        birthDate: "",
        company: "",
        companyType: "",
        voteCount: 0,
        mandates: [] as any,
        status: false
    }

    users = [] as any
    userBeingEdited = false
    filter = null
    sortBy = 'lastName'
    isBusy = true
    rowSelected = false
    sidebarTitle = "Luo uusi käyttäjä"

    fields = [
        { key: 'status', sortable: true, label: "Paikalla" },
        { key: 'companyType', sortable: true, label:"Tyyppi"},
        { key: 'firstName', sortable: true, label: "Etunimi" },
        { key: 'lastName', sortable: true, label: "Sukunimi" },
        { key: 'birthDate', sortable: true, label: "Syntymäaika" },
        { key: 'company', sortable: true, label: "Yritys" },
        { key: 'voteCount', sortable: true, label: "Äänet" },
        { key: 'mandatesCount', sortable: false, label: "Edustukset" }
    ]


    onRowSelected(data: any) {
        if (data.length > 0) {
            this.userBeingEdited = true
            this.userModel = {
                _id: data[0]._id,
                firstName: data[0].firstName,
                lastName: data[0].lastName,
                birthDate: data[0].birthDate,
                company: data[0].company,
                companyType: data[0].companyType,
                voteCount: data[0].voteCount,
                mandates: data[0].mandates,
                status: data[0].status
            }
        } else {
            this.clearUser();
        }
    }

    calcAllVotes(item:any): number {
        let votes = 0;
        if(item.voteCount) votes += parseInt(item.voteCount);
        if(item.mandates && item.mandates.length) votes += item.mandates.reduce((acc:number, cur:any) => { return acc + parseInt(cur.voteCount) }, 0);
        return votes;
    }

    clearUser() {
        this.userBeingEdited = false
        this.userModel = {
            _id: "",
            firstName: "",
            lastName: "",
            birthDate: "",
            company: "",
            companyType: "",
            voteCount: 0,
            mandates: [],
            status: false
        }
    }

    addNewMandate() {
        this.userModel.mandates.push({ id: shortid.generate(), issuer: "", companyType: "", voteCount: "" })
    }
    removeMandate(id: any) {
        this.userModel.mandates.splice(
            this.userModel.mandates.findIndex((x: any) => x.id === id),
            1
        );
    }

    formatTime(time: any) {
        let formattedTime
        if (time != undefined) {
            formattedTime = time.replace(/-/g, "")
            formattedTime = moment(formattedTime).format("DD.MM.YYYY")
        } else {
            formattedTime = ""
        }

        return formattedTime
    }

    newUser() {
        this.$store.dispatch("API_CALL", { method: "post", url: "/users", 
        data: { user: this.userModel, eventId: this.event._id },
        headers: { ['x-access-token']: localStorage.adminToken }}).then((res) => {
            this.users.push(res.data);
        })
        this.clearUser();
    }

    updateUser() {
        this.$store.dispatch("API_CALL", { method: "put", url: "/users", 
        data: { user: this.userModel },
        headers: { ['x-access-token']: localStorage.adminToken }}).then((res) => {
            const updatedUser = res.data.data;
            let newUsers = this.users.slice();
            const i = newUsers.findIndex((usr:any) => usr._id === updatedUser._id);
            newUsers[i] = updatedUser;
            this.users = newUsers;
        })
    }

    saveUserEntry() {
        this.$store.dispatch("API_CALL", { method: "post", url: "/entries", 
        data: { type: "userdata", data: this.users, eventId: this.event._id }}).then((res) => {
            this.$bvToast.toast(res.data.message, {
                autoHideDelay: 3000,
                appendToast: false
            })
        })
    }



    mounted() {
        this.isBusy = true
        this.$store.dispatch('API_CALL', {
            method: "post",
            url: `/users/event-attendees`,
            data: { eventId: this.event._id },
            headers: {
                ["x-access-token"]: localStorage.adminToken
            }
        }).then((res) => {
            for (let user of res.data) {
                this.users.push({
                    _id: user._id,
                    firstName: user.firstName,
                    lastName: user.lastName,
                    birthDate: user.birthDate,
                    company: user.company,
                    companyType: user.companyType,
                    voteCount: user.voteCount,
                    mandatesCount: user.mandates.length,
                    mandates: user.mandates,
                    status: false
                })
            }
            this.socket.emit("refresh_statuses");
            this.isBusy = false
        })

        this.socket.on("online_users", (users:Array<String>) => {
            this.users.forEach((usr:any) => {
                usr.status = false;
            })
            users.forEach((id) => {
                const i = this.users.findIndex((user:any) => user._id === id);
                if(i !== -1) this.users[i].status = true;
            })
        })

    }
    
    get socket(): any {
        return this.$store.state.socket;
    }
    get event(): any {
        return this.$store.state.event;
    }
}
